<template>
  <svg :class="direction" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.1665 10H15.8332M15.8332 10L9.99984 4.16669M15.8332 10L9.99984 15.8334" :stroke="color" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  props: {
    direction: {
      type: String,
      required: true,
      validator: value => ['left', 'right', 'up', 'down'].includes(value),
    },
    color: {
      type: String,
      default: '#414651',
    },
  },
};
</script>

<style lang="scss" scoped>
.left {
  transform: rotate(-180deg);
}

.up {
  transform: rotate(-90deg);
}

.down {
  transform: rotate(90deg);
}
</style>
